
window.dzs_check_lazyloading_images_use_this_element_css_top_instead_of_window_scroll = null;



window.dzs_check_lazyloading_images_tobeloaded_arr = {};
window.dzs_check_lazyloading_images_tobeloaded_arr_ind = 0;
window.dzs_check_lazyloading_images_toberesized_arr = [];
window.dzs_check_lazyloading_inter = 0;

exports.lazyloading_init = function(){





  if(!window.dzs_check_lazyloading_images_inited){


    window.dzs_check_lazyloading_image_resize = function () {


      for (var i = 0; i < window.dzs_check_lazyloading_images_toberesized_arr.length; i++) {
        var $currentImage = window.dzs_check_lazyloading_images_toberesized_arr[i];


        if ($currentImage.hasClass('do-not-set-js-height') === false) {


          var _t = $currentImage;

          /** {number} from 0 - 1 */
          let responsive_ratio = 1;
          if($currentImage.attr('data-responsive_ratio')){
            responsive_ratio = Number($currentImage.attr('data-responsive_ratio'));
          }
          if($currentImage.attr('data-force-responsive_ratio')){
            responsive_ratio = Number($currentImage.attr('data-force-responsive_ratio'));
          }
          if($currentImage.attr('data-thumbnail-height')){
            responsive_ratio = Number($currentImage.attr('data-thumbnail-height'));
          }
          if (_t.hasClass('divimage')) {
            _t.css({
              'padding-top': (responsive_ratio * 100) + '%'
              , 'height': '0'
            })
          } else {
            $currentImage.height(responsive_ratio * $currentImage.width());
          }
        }
      }
    }


    window.dzs_check_lazyloading_images = function () {
      function check_scroll() {
        var scrollTopPosition = jQuery(window).scrollTop();
        var windowHeight = jQuery(window).height();

        if (window.dzs_check_lazyloading_images_use_this_element_css_top_instead_of_window_scroll) {

          scrollTopPosition = -(parseInt(window.dzs_check_lazyloading_images_use_this_element_css_top_instead_of_window_scroll.css('top'), 10));
        }

        for (var lab in dzs_check_lazyloading_images_tobeloaded_arr) {
          var _t = dzs_check_lazyloading_images_tobeloaded_arr[lab];

          if (_t.offset().top <= scrollTopPosition + windowHeight + 120) {
            if (_t.hasClass('lazyloading-dom-element')) {
              setTimeout(function (argt, arglab) {
                argt.addClass('loaded');
                delete dzs_check_lazyloading_images_tobeloaded_arr[arglab];
              }, 200, _t, lab);
            }

            if (_t.attr('data-img-src')) {
              var auximg = new Image();

              auximg.arglab = lab;
              auximg.argt = _t;

              auximg.onload = function () {

                var _t = this.argt;
                var lab2 = this.arglab;


                if (_t.attr('data-img-src')) {

                  var aux34 = _t.attr('data-img-src');


                  if (_t.hasClass('divimage')) {
                    _t.css('background-image', 'url(' + aux34 + ')');

                    window.dzs_check_lazyloading_images_toberesized_arr.push(_t);

                    if (_t.hasClass('dzsparallaxer--target')) {
                      return;
                    }
                    _t.attr('data-responsive_ratio', this.naturalHeight / this.naturalWidth);

                    window.dzs_check_lazyloading_image_resize();
                  } else {
                    _t.attr('src', aux34);
                  }


                  if (_t.attr('data-temp-rat')) {
                    if (_t.hasClass('divimage')) {
                      _t.css({
                        'padding-top': (Number(_t.attr('data-temp-rat')) * 100) + '%'
                        , 'height': '0'
                      })
                    }
                  }

                  _t.attr('data-img-src', '');
                  _t.addClass('loaded');



                  delete dzs_check_lazyloading_images_tobeloaded_arr[lab2];

                }

                if (_t.hasClass('set-height-auto-after-load')) {

                  _t.css('height', 'auto');
                }

                if (_t.parent().parent().parent().parent().parent().hasClass('mode-isotope')) {

                  var _c = _t.parent().parent().parent().parent().parent();
                  if (_c.get(0) && _c.get(0).api_relayout_isotope) {
                    _c.get(0).api_relayout_isotope();
                  }
                }


                // -- end onload
              }

              auximg.src = _t.attr('data-img-src');
            }


            if (_t.attr('data-script-src')) {


              jQuery('<script/>', {
                src: _t.attr('data-script-src')
              }).appendTo('head');


              _t.attr('data-script-src', '');

              delete dzs_check_lazyloading_images_tobeloaded_arr[lab];

            }
            if (_t.attr('data-stylesheet-src')) {

              jQuery('<link/>', {
                rel: 'stylesheet',
                type: 'text/css',
                href: _t.attr('data-stylesheet-src')
              }).appendTo('head');


              _t.attr('data-stylesheet-src', '');
              delete dzs_check_lazyloading_images_tobeloaded_arr[lab];


            }

          }
        }
      }

      if (window.dzs_check_lazyloading_inter) {
        clearTimeout(window.dzs_check_lazyloading_inter);
      }

      check_scroll()

    }

  }


















  var $ = jQuery;
  init();



  function addDomElementsToQueue() {
    const imgSelector = 'img[data-img-src],.divimage[data-img-src],*[data-script-src], *[data-stylesheet-src],.lazyloading-dom-element';
    jQuery(imgSelector).each(function () {

      var _t = $(this);
      if (_t.hasClass('dzsparallaxer--target')) {
        return;
      }

      if (_t.attr('data-temp-rat')) {
        var temp_rat = Number(_t.attr('data-temp-rat'));
        if (_t.hasClass('divimage')) {
          _t.css({
            'padding-top': (Number(_t.attr('data-responsive_ratio')) * 100) + '%',
             'height': '0'
          })
        } else {

          _t.css({
            'height': (temp_rat * _t.outerWidth(false)) + 'px'
          });
        }
      }

      dzs_check_lazyloading_images_tobeloaded_arr[dzs_check_lazyloading_images_tobeloaded_arr_ind++] = _t;
    });
  }

  function init(){

    if(!window.dzs_check_lazyloading_images_inited){
      window.dzs_check_lazyloading_images_tobeloaded_arr = {};
      window.dzs_check_lazyloading_images_tobeloaded_arr_ind = 0;
    }




    reinit();

    if(!window.dzs_check_lazyloading_images_inited) {
      $(window).bind('scroll.dzslazy', window.dzs_check_lazyloading_images);
      setTimeout(function () {
        window.dzs_check_lazyloading_images();
      }, 1500);
      setTimeout(function () {
        window.dzs_check_lazyloading_images();
      }, 2500);


      window.dzs_check_lazyloading_images_inited = true;
    }
  }

  function reinit() {

    addDomElementsToQueue();
    window.dzs_check_lazyloading_images();
  }



  window.lazyloading_reinit = reinit;


}

